<script setup lang="ts">
import ImageNoAccess from '~/assets/error-no-access.svg?url';
import { useGlobalMerchant } from '~/composables/useGlobalMerchant';

const router = useRouter();
const route = useRoute();
const merchant = useGlobalMerchant();

const loginRedirect = merchant.value
	? router.resolve({ name: 'MerchantLogin', params: { merchantSlug: merchant.value.slug }, query: { redirectTo: route.path } })
	: router.resolve({ name: 'GlobalLogin', query: { redirectTo: route.path } });

const logoutRedirect = merchant.value
	? router.resolve({ name: 'MerchantLogout', params: { merchantSlug: merchant.value.slug }, query: { redirectTo: loginRedirect.fullPath } })
	: router.resolve({ name: 'GlobalLogin', query: { redirectTo: loginRedirect.fullPath } });
</script>

<template>
	<ErrorScreen
		:title="$t('error.noAdmin.title')"
		:subtitle="$t('error.noAdmin.subtitle')"
		:image="ImageNoAccess"
	>
		<div class="space-x-2">
			<UButton
				to="/"
				size="lg"
				color="neutral"
				variant="outline"
			>
				{{ $t('button.backToHome') }}
			</UButton>
			<UButton
				:to="logoutRedirect"
				size="lg"
				color="neutral"
				variant="outline"
			>
				{{ $t('button.logout') }}
			</UButton>
		</div>
	</ErrorScreen>
</template>
